import styled from 'styled-components'

import theme from '../../../utils/theme'

const BreadCrumbWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-top: 20px;
  .bread-crumb-back,
  .bread-crumb-next {
    padding-right: '0.625rem';
    color: var(--gameday-body-textColorAlt, ${theme.body.textColorAlt});
  }
  .bread-crum-link {
    text-decoration: none;
    color: var(--gameday-body-textColorAlt, ${theme.body.textColorAlt});
  }
`

export default BreadCrumbWrapper
